// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { contactFormStyles } from "@insite/content-library/Widgets/ContactUs/ContactForm";
import { DivWrapper } from "@sc/XDL/constants";
import { mergeWithCss } from "@sc/XDL/Utilities";
import { css } from "styled-components";

contactFormStyles.formGridItem = {
    width: 12,
    css: css`
        form {
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 20px;
            > ${DivWrapper} {
                display: flex;
                flex-direction: column;
                gap: 20px;
            }
        }
    `,
};

contactFormStyles.submitButton = mergeWithCss(contactFormStyles.submitButton, {
    css: css`
        width: fit-content;
        margin-top: 0;
        margin-left: auto;
    `,
});
